


















export default {
  data () {
    return {
      skills: [
        {
          title: 'Php',
          skills: [
            'Symfony',
            'Laravel'
          ]
        },
        {
          title: 'Javascript',
          skills: [
            'Vanilla',
            'jQuery',
            'Angular',
            'NodeJs'
          ]
        },
        {
          title: 'UI/UX Design',
          skills: [
            'Bootstrap',
            'HTML',
            'CSS',
            'SASS'
          ]
        },
        {
          title: 'DevOps',
          skills: [
            'MySQL',
            'PostgreSQL',
            'Linux/Server Administration',
            'Docker',
            'CI/CD',
            'TravisCI',
            'System Deployment',
            'Heroku',
            'MongoDB'
          ]
        },
        {
          title: 'Others',
          skills: [
            'Git',
            'GitHub/GitLab',
            'SCRUM and Agile Development Processes',
            'RabbitMQ',
            'ElasticSearch'
          ]
        }
      ]
    }
  }
}
